import { gql } from "generated-graphql";

// Every operation returns the same detail selection (via the fragment
// below), so one response updates the whole screen no matter which action
// produced it.

export const CUSTOM_WORK_DETAIL_FRAGMENT = gql(`
  fragment CustomWorkDetailFields on CustomWorkItemDetail {
    workflowId
    name
    description
    status
    tenantId
    tenantName
    programArea
    dueAt
    dueType
    workTypeLabel
    completedAt
    createdAt
    steps {
      id
      description
      status
      position
      assigneeId
      assigneeEmail
      isCurrent
      statusChangedAt
      statusChangedByEmail
      documents {
        documentId
        title
        documentType
        fileExtension
        activityId
        stepDescription
        attachedAt
        attachedByEmail
      }
    }
    comments {
      ...CommentThread
    }
    documents {
      documentId
      title
      documentType
      fileExtension
      activityId
      stepDescription
      attachedAt
      attachedByEmail
    }
    history {
      id
      time
      kind
      stepId
      stepDescription
      status
      actorEmail
    }
  }
`);

export const CUSTOM_WORK_ITEM_QUERY = gql(`
  query CustomWorkItem($workflowId: ID!) {
    customWorkItem(workflowId: $workflowId) {
      ...CustomWorkDetailFields
    }
  }
`);

export const ADD_CUSTOM_WORK_STEP = gql(`
  mutation AddCustomWorkStep($workflowId: ID!, $description: String!) {
    addCustomWorkStep(workflowId: $workflowId, description: $description) {
      ...CustomWorkDetailFields
    }
  }
`);

export const START_CUSTOM_WORK_STEP = gql(`
  mutation StartCustomWorkStep($activityId: ID!) {
    startCustomWorkStep(activityId: $activityId) {
      ...CustomWorkDetailFields
    }
  }
`);

export const COMPLETE_CUSTOM_WORK_STEP = gql(`
  mutation CompleteCustomWorkStep($activityId: ID!) {
    completeCustomWorkStep(activityId: $activityId) {
      ...CustomWorkDetailFields
    }
  }
`);

export const SKIP_CUSTOM_WORK_STEP = gql(`
  mutation SkipCustomWorkStep($activityId: ID!) {
    skipCustomWorkStep(activityId: $activityId) {
      ...CustomWorkDetailFields
    }
  }
`);

export const REOPEN_CUSTOM_WORK_STEP = gql(`
  mutation ReopenCustomWorkStep($activityId: ID!) {
    reopenCustomWorkStep(activityId: $activityId) {
      ...CustomWorkDetailFields
    }
  }
`);

export const ATTACH_DOCUMENT_TO_CUSTOM_WORK = gql(`
  mutation AttachDocumentToCustomWork($workflowId: ID!, $documentId: ID!) {
    attachDocumentToCustomWork(workflowId: $workflowId, documentId: $documentId) {
      ...CustomWorkDetailFields
    }
  }
`);

export const REMOVE_DOCUMENT_FROM_CUSTOM_WORK = gql(`
  mutation RemoveDocumentFromCustomWork($workflowId: ID!, $documentId: ID!) {
    removeDocumentFromCustomWork(workflowId: $workflowId, documentId: $documentId) {
      ...CustomWorkDetailFields
    }
  }
`);
